import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LabOrdersMobile from './labOrdersMobile';
import LabOrdersWeb from './labOrdersWeb';
import PlanUpgradeDialog from '../components/planUpgradeDialog/planUpgradeDialog';
import { hasPlanAtLeast, useTenantSubscription } from '../hooks/useTenantSubscription';

const MOBILE_BREAKPOINT = 768;

// Clinics below PLUS can look around the screen for a while before being told it's a PLUS feature.
const PLAN_NOTICE_DELAY_IN_MS = 30000;

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

export default function LabOrdersRouter() {
  const width = useWindowWidth();
  const navigate = useNavigate();
  const { fetchSubscription } = useTenantSubscription();
  const [showPlanNotice, setShowPlanNotice] = useState(false);

  // Lives here (not in the web/mobile screens) so resizing across the breakpoint doesn't restart the timer.
  useEffect(() => {
    let timer;
    let active = true;
    fetchSubscription()
      .then((subscription) => {
        if (active && !hasPlanAtLeast(subscription, 'PLUS')) {
          timer = setTimeout(() => setShowPlanNotice(true), PLAN_NOTICE_DELAY_IN_MS);
        }
      })
      // If the plan can't be checked, don't punish the user: the screen stays available.
      .catch(() => {});

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [fetchSubscription]);

  // Closing the notice leaves the screen, so the user can't keep using the feature.
  const handleClosePlanNotice = () => {
    setShowPlanNotice(false);
    navigate('/home');
  };

  return (
    <>
      {width < MOBILE_BREAKPOINT ? <LabOrdersMobile /> : <LabOrdersWeb />}
      <PlanUpgradeDialog
        open={showPlanNotice}
        onClose={handleClosePlanNotice}
        feature="O controle de envios ao laboratório"
      />
    </>
  );
}
